module.exports = __webpack_public_path__ + "static/media/bottomNew.a9796204.png";